import { GetterTree } from 'vuex';

import { TimeSyncState } from './types';

export const getters: GetterTree<TimeSyncState, any> = {
  offset: (state: TimeSyncState): number => state.offset
};
